export default {"src":"/_next/static/media/events.dc3c1979.svg","height":416,"width":834,"blurWidth":0,"blurHeight":0};